import { takeLatest } from 'redux-saga/effects';

import { CONTENT, CATEGORY_CONTENTS } from 'actions/content.actions';
import { getContentSaga, getCategoryContentsSaga } from 'sagas/content.saga';
import { REQUEST } from 'services/api';

export function* getContentSagaWatcher(): unknown {
  yield takeLatest(CONTENT[REQUEST], getContentSaga);
}

export function* getCategoryContentsSagaWatcher(): unknown {
  yield takeLatest(CATEGORY_CONTENTS[REQUEST], getCategoryContentsSaga);
}
